// Copyright (c) 2016 Deere & Company

import SearchFilters from '../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['pipNumber'],
        sortDirection: 'ASC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/pip/pip-search/state/search-filters.js